import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';


const ctSchedule = lazy(() => import('../../container/ct-schedule'));
const ctScheduleView = lazy(() => import('../../container/ct-schedule-view'));

const CTSchedule = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/ctSchedule`} component={ctSchedule}/>
            <Route path={`${path}/ctScheduleView`} component={ctScheduleView}/>
        </Switch>
    );
};

export default CTSchedule;
